<template>
    <section class="container-fluid stepsBar vld-parent" ref="ref_payout">
        <div class="container mt-md-5 pb-5" sty>
            <div class="row">
                <div class="col-md-10 offset-md-1">
                    <div>
                        <h1 class="mb-4 wow fadeInUp h2 text-center">Payout Settings</h1>
                    </div>

                    <p class="alert alert-danger"
                        v-if="account_details &&  ['business_type'].some(r=> requirements.indexOf(r) >= 0)"> Card
                        payments, payouts and transfers are disabled for this account until a business type is added.
                    </p>
                    <p class="alert alert-danger"
                        v-if="account_details &&  ['business_profile.mcc',  'business_profile.url',  'representative.first_name', 'representative.last_name', 'tos_acceptance.date', 'tos_acceptance.ip'].some(r=> requirements.indexOf(r) >= 0)">
                        Card payments, payouts and transfers are disabled for this account until missing business
                        information is updated.</p>

                    <p class="alert alert-danger"
                        v-if="account_details &&  ['external_account'].some(r=> requirements.indexOf(r) >= 0)">Add a bank account or debit card to enable payouts.</p>

                    <section v-if="user">
                        <button type="button" class="btn btn-primary" @click="create_stripe_account()"
                            v-if="!user.payout_account">Ready to Payout</button>

                        <button type="button" class="btn btn-primary" @click="stripe_account_update()"
                            v-if="account_details">{{ ['business_type','business_profile.mcc',  'business_profile.url',  'representative.first_name', 'representative.last_name', 'tos_acceptance.date', 'tos_acceptance.ip','external_account'].some(r=> requirements.indexOf(r) >= 0) ? 'Update Setting to enable Payout':'Update Setting'}}</button>

                        <div class="row" v-if="account_details">
                            <div class="col-md-6">
                                <h3 class="mb-4">Account Information</h3>

                                <div class="table-responsive">
                                    <table class="table table-striped">
                                        <tbody>
                                            <tr>
                                                <td class="textBold600">Name</td>
                                                <td v-if="account_details.individual">{{ account_details.individual.first_name }}
                                                    {{ account_details.individual.last_name }}</td>
                                                    <td v-else>-</td>
                                            </tr>
                                            <tr>
                                                <td class="textBold600">Address</td>
                                                <td  v-if="account_details.individual && account_details.individual.address">{{ account_details.individual.address.line1 }}
                                                    {{ account_details.individual.address.line2 }}
                                                    {{ account_details.individual.address.city }}
                                                    {{ account_details.individual.address.state }}
                                                    {{ account_details.individual.address.country }}
                                                    {{ account_details.individual.address.postal_code }}</td>
                                                    <td v-else>-</td>
                                            </tr>
                                            <tr>
                                                <td class="textBold600">Email</td>
                                                <td v-if="account_details.individual" v-html="account_details.individual.email"></td>
                                                <td v-else>-</td>
                                            </tr>
                                            <tr>
                                                <td class="textBold600">Phone</td>
                                                <td v-if="account_details.individual" v-html="account_details.individual.phone"></td>
                                                <td v-else>-</td>
                                            </tr>
                                            <tr>
                                                <td class="textBold600">Business Type</td>
                                                <td v-html="account_details.business_type" v-if="account_details.business_type"> </td>
                                                <td v-else>-</td>
                                            </tr>
                                            <tr>
                                                <td class="textBold600">Company Address</td>
                                                <td v-if="account_details.company && account_details.company.address">{{ account_details.company.address.line1 }}
                                                    {{ account_details.company.address.line2 }}
                                                    {{ account_details.company.address.city }}
                                                    {{ account_details.company.address.state }}
                                                    {{ account_details.company.address.country }}
                                                    {{ account_details.company.address.postal_code }}</td>
                                                    <td v-else>-</td>
                                            </tr>
                                            <tr>
                                                <td class="textBold600">Payout</td>
                                                <td>
                                                    <span v-if="account_details.payouts_enabled">Enabled</span>
                                                    <span v-else>Disabled</span>
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>

                            </div>
                            <div class="col-md-6">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="mb-4 clearfix">
                                            <h3 class="float-left mr-3">Card / Bank Details </h3> <button type="button"
                                                class="btnNormal m-0 float-left font12 py-1 px-4" data-toggle="modal"
                                                data-target="#cardModal">+ Add</button>
                                        </div>

                                        <div class="accordion" id="accordSection"
                                            v-if="account_details && account_details.external_accounts && account_details.external_accounts.data">


                                            <div class="card border-left-0 border-right-0 border-top-0"
                                                v-for="(item, index) in account_details.external_accounts.data"
                                                :key="index">
                                                <div class="card-header bg-white" :id="'accordSectionHead'+index">
                                                    <h2 class="mb-0 font14 d-flex align-items-center">
                                                        <button
                                                            class="btnTransparent angelIconLeft textBold600 d-block w-100 text-left collapsed"
                                                            type="button" data-toggle="collapse"
                                                            :data-target="'#collapseAccordmat'+index"
                                                            aria-expanded="false"
                                                            :aria-controls="'#collapseAccordmat'+index">
                                                            {{item.object== 'card'? item.brand + ' **** **** **** ' + item.last4 : item.bank_name}}
                                                            ({{ item.currency }}) <span class="badge badge-warning"
                                                                v-if="item.default_for_currency">Default</span>
                                                        </button>

                                                        <div class="dropdown" v-if="!item.default_for_currency">
                                                            <button class="btnNormal dropdown-toggle p-2 py-1"
                                                                type="button" id="aside" data-toggle="dropdown"
                                                                aria-expanded="false">
                                                            </button>
                                                            <div class="dropdown-menu" aria-labelledby="aside">
                                                                <a class="dropdown-item" href="javascript:void(0);"
                                                                    @click="set_as_default(item.id)"><i
                                                                        class="fa fa-check-square-o"
                                                                        aria-hidden="true"></i> Set as Default</a>
                                                                <a class="dropdown-item" href="javascript:void(0);"
                                                                    @click="remove_account(item.id,index)"><i
                                                                        class="fa fa-minus-circle"
                                                                        aria-hidden="true"></i> Remove</a>
                                                            </div>
                                                        </div>
                                                    </h2>
                                                </div>
                                                <div :id="'collapseAccordmat'+index" class="collapse"
                                                    :aria-labelledby="'accordSectionHead'+index"
                                                    data-parent="#accordSection">
                                                    <div class="card-body p-0">
                                                        <div class="form-group mt-3">
                                                            <div class="table-responsive">
                                                                <table class="table table-striped">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td class="textBold600">Type</td>
                                                                            <td v-if="item.object=='card'">
                                                                                {{ item.brand }} {{ item.funding }}
                                                                                {{ item.object }}</td>
                                                                            <td v-else>Bank account</td>
                                                                        </tr>
                                                                        <tr v-if="item.object=='bank_account'">
                                                                            <td class="textBold600">Account holder</td>
                                                                            <td>{{ item.account_holder_name }}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td class="textBold600">Origin</td>
                                                                            <td>{{ item.country }}</td>
                                                                        </tr>
                                                                        <tr v-if="item.object=='card'">
                                                                            <td class="textBold600">Expires</td>
                                                                            <td>{{ item.exp_month }}/{{ item.exp_year }}
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td class="textBold600">Fingerprint</td>
                                                                            <td>{{ item.fingerprint }}</td>
                                                                        </tr>
                                                                        <tr v-if="item.object=='card'">
                                                                            <td class="textBold600">CVC</td>
                                                                            <td>{{ item.cvc_check }}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                    <!--             <div class="col-md-12 d-flex justify-content-end mt-4">

                <button type="button" class="btnNormal m-0 font12  py-1 px-4" data-toggle="modal" data-target="#accountModal">Add Account</button>
            </div> -->
                                </div>
                            </div>
                        </div>



                    </section>
                </div>
            </div>
        </div>



<!-- Card/bank add modal -->

        <div class="modal fade" id="cardModal" tabindex="-1" role="dialog" aria-labelledby="cardModal"
            aria-hidden="true">
            <div class="modal-dialog" role="document">
                <form class="modal-content" @submit.prevent="add_external_account()">
                    <div class="modal-header">
                        <h5 class="modal-title" id="cardModalLabel">Card/Bank Details</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body vld-parent" ref="modbd_ref">

                        <div class="col-sm-12">
                            <div class="d-flex justify-content-between mb-4">
                                <div class="form-check">
                                    <label class="form-check-label">
                                        <input type="radio" class="form-check-input" name="optradio" value="Card"
                                            v-model="addfrm.type">Card
                                    </label>
                                </div>
                                <div class="form-check">
                                    <label class="form-check-label">
                                        <input type="radio" class="form-check-input" name="optradio" value="Bank"
                                            v-model="addfrm.type">Bank Account
                                    </label>
                                </div>
                            </div>

                            <transition name="fade" mode="out-in">
                                <div class="card" v-if="addfrm.type && addfrm.type=='Card'" key="dc">
                                    <div class="card-header">
                                        <strong>Credit/Debit Card</strong>
                                        <small>enter your card details</small>
                                    </div>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="form-group">
                                                    <label for="name">Name</label>
                                                    <input class="formControl w-100" id="name" type="text"
                                                        placeholder="Enter your name" v-model="addfrm.card_name" v-validate="'required'" data-vv-as="name" name="name">
                                                </div>
                                                <p v-if="verrors.has('card_name')" class="errormsg">{{ verrors.first('card_name') }} </p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="form-group">
                                                    <label for="ccnumber">Credit Card Number</label>
                                                    <div class="input-group">
                                                        <input class="formControl" type="text"
                                                            placeholder="0000 0000 0000 0000"
                                                            v-model="addfrm.card_number" v-validate="'required'" data-vv-as="Card Number" name="card_number">
                                                        <div class="input-group-append">
                                                            <span class="input-group-text">
                                                                <i class="fa fa-credit-card" aria-hidden="true"></i>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                 <p v-if="verrors.has('card_number')" class="errormsg">{{ verrors.first('card_number') }} </p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="form-group col-sm-4">
                                                <label for="ccmonth">Month</label>
                                                <select class="formControl w-100" id="ccmonth" v-model="addfrm.exp_month" v-validate="'required'" data-vv-as="expiry month" name="exp_month">
                                                    <option>1</option>
                                                    <option>2</option>
                                                    <option>3</option>
                                                    <option>4</option>
                                                    <option>5</option>
                                                    <option>6</option>
                                                    <option>7</option>
                                                    <option>8</option>
                                                    <option>9</option>
                                                    <option>10</option>
                                                    <option>11</option>
                                                    <option>12</option>
                                                </select>
                                            </div>
                                            <div class="form-group col-sm-4">
                                                <label for="ccyear">Year</label>
                                                <select class="formControl w-100" id="ccyear" v-model="addfrm.exp_year" v-validate="'required'" data-vv-as="expiry year" name="exp_year" >

                                                    <option v-for="(year, index) in years" :key="index">{{ year }}
                                                    </option>

                                                </select>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <label for="cvv">CVV/CVC</label>
                                                    <input class="formControl w-100" id="cvv" type="text" placeholder="123" v-model="addfrm.cvc" v-validate="'required'" data-vv-as="CVV/CVC" name="cvc">
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <p v-if="verrors.has('exp_month')" class="errormsg">{{ verrors.first('exp_month') }} </p>
                                                <p v-if="verrors.has('exp_year')" class="errormsg">{{ verrors.first('exp_year') }} </p>
                                                <p v-if="verrors.has('cvc')" class="errormsg">{{ verrors.first('cvc') }} </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="card" v-else key="dac">
                                    <div class="card-header">
                                        <strong>Bank transfer</strong>
                                        <small>enter your bank details</small>
                                    </div>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="form-group">
                                                    <label for="name">Name</label>
                                                    <input class="formControl w-100" id="name" type="text"
                                                        placeholder="Enter your name" v-model="addfrm.account_holder_name" v-validate="'required'" data-vv-as="name" name="name">
                                                </div>
                                                <p v-if="verrors.has('account_holder_name')" class="errormsg">{{ verrors.first('account_holder_name') }} </p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="form-group">
                                                    <label for="ccnumber">Routing Number</label>
                                                    <div class="input-group">
                                                        <input class="formControl w-100" type="text"
                                 v-model="addfrm.routing_number" v-validate="'required'" data-vv-as="Routing Number" name="routing_number">
                                                    </div>
                                                </div>
                                                 <p v-if="verrors.has('routing_number')" class="errormsg">{{ verrors.first('routing_number') }} </p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="form-group">
                                                    <label for="ccnumber">Account Number</label>
                                                    <div class="input-group">
                                                        <input class="formControl w-100" type="text"
                                 v-model="addfrm.account_number"  v-validate="'required'" data-vv-as="Account Number" name="account_number">
                                                    </div>
                                                </div>
                                                 <p v-if="verrors.has('account_number')" class="errormsg">{{ verrors.first('account_number') }} </p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="form-group col-sm-12">
                                                <label for="ccmonth">Account holder type</label>
                                                <select class="formControl w-100" id="ccmonth" v-model="addfrm.account_holder_type" v-validate="'required'" data-vv-as="Account holder type" name="account_holder_type">
                                                    <option value="individual">Individual</option>
                                                    <option value="company">Company</option>
                                                </select>
                                                <p v-if="verrors.has('account_holder_type')" class="errormsg">{{ verrors.first('account_holder_type') }} </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </transition>

                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="submit" class="btn btn-primary">Update</button>
                    </div>
                </form>
            </div>
        </div>




    </section>
</template>

<script>
    import {
        mapGetters,
        mapActions
    } from "vuex";
    import {
        log
    } from 'util';
    export default {
        name: "PayoutSettings",
        components: {

        },
        data() {
            return {
                account_details: '',
                requirements: [],
                years: [...Array(16)].map((a, b) => new Date().getFullYear() + b),
                addfrm: {
                    type: 'Card',
                    account_holder_type: 'individual'
                },
            }
        },
        watch: {
            'account_details.requirements': {
                handler(items) {
                    if (items.disabled_reason == 'requirements.past_due') {
                        this.requirements = this.account_details.requirements.past_due
                    } else if (items.disabled_reason == 'requirements.currently_due') {
                        this.requirements = this.account_details.requirements.currently_due
                    } else if (items.disabled_reason == 'requirements.eventually_due') {
                        this.requirements = this.account_details.requirements.eventually_due
                    } else if (items.disabled_reason == 'requirements.pending_verification') {
                        this.requirements = this.account_details.requirements.pending_verification
                    }
                },
                deep: true
            },

        },
        updated: function () {
            this.$nextTick(function () {

            })
        },
        beforeCreate() {
            let loaderd = this.$loading.show({
                container: this.$refs.ref_payout,
            });
            axios.get('/api/payout_setup')
                .then(res => {
                    if (res.data.success == true)
                        this.account_details = res.data.data
                    loaderd.hide();
                })
                .catch(err => {
                        loaderd.hide()
                    })
        },
        methods: {
            ...mapActions("auth", ["sendLogoutRequest", "getUserData"]),
            async create_stripe_account() {
                let loaderd = this.$loading.show({
                    container: this.$refs.ref_payout,
                });
                axios.post('/api/payout_setup', {})
                    .then(res => {
                        loaderd.hide()
                        if (res.data.success == true) {
                            window.location.href = res.data.data.url;
                        }
                    })
                    .catch(err => {
                        loaderd.hide()
                    })
            },
            async stripe_account_update() {
                let loaderd = this.$loading.show({
                    container: this.$refs.ref_payout,
                });
                axios.get('/api/payout_setup/1')
                    .then(res => {
                        loaderd.hide()
                        if (res.data.success == true) {
                            window.location.href = res.data.data.url;
                        }
                    })
                    .catch(err => {
                        loaderd.hide()
                    })
            },
            async set_as_default(id) {
                let loaderd = this.$loading.show({
                    container: this.$refs.ref_payout,
                });

                axios.put('/api/payout_setup/' + id, {})
                    .then(res => {
                        if (res.data.success == true) {
                            this.account_details.external_accounts = res.data.data
                        }
                        Toast.fire({
                            icon: 'success',
                            title: res.data.message
                        });
                        loaderd.hide()
                    })
                    .catch(err => {
                        loaderd.hide()
                    })

            },
            async remove_account(id, x) {
                let loaderd = this.$loading.show({
                    container: this.$refs.ref_payout,
                });
                axios.delete('/api/payout_setup/' + id)
                    .then(res => {
                        Toast.fire({
                            icon: 'success',
                            title: res.data.message
                        });
                        if (res.data.success == true && res.data.data.deleted == true) {
                            this.account_details.external_accounts.data.splice(x, 1);
                        }
                        loaderd.hide()
                    })
                    .catch(err => {
                        loaderd.hide()
                    })
            },


            async add_external_account() {
                await this.$validator.validate().then((valid) => {
                    if (valid) {
                        let loaderd = this.$loading.show({
                            container: this.$refs.modbd_ref,
                        });
                        axios.post('/api/external_account', this.addfrm)
                            .then(res => {
                                if (res.data.success == true) {
                                    $('#cardModal').modal('hide');
                                    this.addfrm = {
                                        type: 'Card',
                                        account_holder_type: 'individual'
                                    }
                                    this.account_details.external_accounts = res.data.data
                                }
                                Toast.fire({
                                    icon: 'success',
                                    title: res.data.message
                                });
                                loaderd.hide()
                            })
                            .catch(err => {
                                loaderd.hide()
                            })
                    }
                });
            }


        },
        async mounted() {
            this.$store.commit("setErrors", {});
        },
        async created() {

        },
        filters: {},
        computed: {
            ...mapGetters("auth", ["user"]),
            ...mapGetters(["errors"]),
        },

    }
</script>
<style scoped>
    .accordion>.card {
        overflow: visible;
    }
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to {
  opacity: 0
}
</style>
